// src/games/darkforest/scenes/index.js
import { forest_entry } from './forest_entry';
import { forest_path } from './forest_path';
import { clearing } from './clearing';
import { ruins } from './ruins';
import { river } from './river';

export {
  forest_entry,
  forest_path,
  clearing,
  ruins,
  river
};

export const scenes = {
  ...forest_entry,
  ...forest_path,
  ...clearing,
  ...ruins,
  ...river
};